import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "load-more",
  "use": "load-more-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"load-more\"><g fill-rule=\"evenodd\"><path d=\"M8 13.364L2.697 8.061l.707-.707L8 11.95l4.596-4.596.707.707z\" /><path d=\"M8.5 12.657h-1V1.689h1z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol